import "./index.scss";
import { DoubleContentBlockProps } from "./types";
import {
  getAlignItemsClassNames,
  getJustifyContentClassNames,
} from "utilities/commonPropTypes/flex";
import { getBackgroundClassNames } from "utilities/commonPropTypes/background";
import { getSpacersClassNames } from "utilities/commonPropTypes/spacers";
import React from "react";
import classNames from "classnames";

const DoubleContentBlock = ({
  alignItems,
  children,
  customClass,
  justifyContent,
  marginBottom,
  marginTop,
  paddingBottom,
  paddingTop,
}: DoubleContentBlockProps) => {
  const doubleContentBlockClasses = classNames(
    "DoubleContentBlock",
    customClass,
    getSpacersClassNames({
      marginBottom,
      marginTop,
      paddingBottom,
      paddingTop,
    }),
    getJustifyContentClassNames({
      justifyContent,
    }),
    getAlignItemsClassNames({
      alignItems,
    }),
  );

  return (
    <div data-testid="contentWrapper" className={doubleContentBlockClasses}>
      {children}
    </div>
  );
};

export default DoubleContentBlock;
